import { useState } from "react";
import {
    Button,
    TextField,
    Box,
    Typography,
    Paper,
    CircularProgress,
} from "@mui/material";
import { Link } from 'react-router-dom';
import api from '../../services/api.js';

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setError("");
        setMessage("");
        setLoading(true);

        if (!email) {
            setError("Preencha o e-mail.");
            setLoading(false);
            return;
        }

        try {
            await api.post('/auth/forgot-password', { email: email.trim() });
            setMessage("Se o e-mail estiver cadastrado, você receberá um link para redefinição de senha.");
        } catch (err) {
            console.error("Erro ao solicitar recuperação:", err);
            if (err.response?.data?.error) {
                setError(err.response.data.error);
            } else {
                setError("Erro ao conectar com o servidor. Tente novamente.");
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box
            sx={{
                minHeight: '100vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: '#000000',
                padding: 2,
                position: 'relative',
                overflow: 'hidden'
            }}
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundImage: 'url(/fundo_login.png?v=6)',
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    opacity: 0.5,
                    zIndex: 0,
                }}
            />
            <Paper
                elevation={8}
                sx={{
                    position: 'relative',
                    zIndex: 1,
                    padding: 4,
                    borderRadius: 3,
                    maxWidth: 400,
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >
                <Box
                    component="img"
                    src="/logo_empresa.png"
                    alt="Logo da Empresa"
                    sx={{
                        width: 180,
                        height: 180,
                        objectFit: 'contain',
                        mb: 2
                    }}
                />
                <Typography variant="h5" component="h1" gutterBottom align="center">
                    Recuperar Senha
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }} align="center">
                    Informe seu e-mail para receber as instruções.
                </Typography>

                {message && (
                    <Typography color="success.main" sx={{ mb: 2, textAlign: 'center' }}>
                        {message}
                    </Typography>
                )}

                {error && (
                    <Typography color="error" sx={{ mb: 2, textAlign: 'center' }}>
                        {error}
                    </Typography>
                )}

                <Box component="form" onSubmit={handleSubmit} noValidate sx={{ width: '100%' }}>
                    <TextField
                        margin="normal"
                        fullWidth
                        id="email"
                        label="E-mail"
                        name="email"
                        autoComplete="email"
                        autoFocus
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        disabled={loading || !!message}
                    />
                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        sx={{ mt: 3, mb: 2, py: 1.5, bgcolor: '#20ac9c', '&:hover': { bgcolor: '#167a6f' } }}
                        disabled={loading || !!message}
                    >
                        {loading ? <CircularProgress size={24} color="inherit" /> : 'Enviar E-mail'}
                    </Button>
                    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
                        <Link to="/login" style={{ color: '#20ac9c', textDecoration: 'none' }}>
                            Voltar ao Login
                        </Link>
                    </Box>
                </Box>
            </Paper>
        </Box>
    );
}
